module.exports = __webpack_public_path__ + "static/tiktok_time-2751d1a2389e81b857214b1043c469d2.svg";